export const parseTrsMetadata = (filePath: string) => {
    const match = filePath.match(/\/content\/(.*?).trs#time=(.*)/);
    if (!match) return null;

    const id = match[1];
    const time = match[2];
    const offsetSecs = parseInt(time);

    return { id, offsetSecs };
};
